export enum PrintOrderStatus {
    Created = 1,
    InProgress = 2,
    Completed = 3,
    Collected = 4,
    Canceled = 5
  }
  